import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { Field } from "vee-validate";
import { Address } from "@/types/index";
import TextInput from "@/components/shared/inputs/TextInput.vue";
import KakaoAddressModal from "../modal/KakaoAddressModal.vue";
import PageModal from "../modal/base/PageModal.vue";


const __default__ = {
  name: "AddressInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  label: {
    type: String,
    default: "주소",
  },
  name: {
    type: String,
    default: "address",
  },
  placeholder: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: true,
  },
  value: {
    type: null as any,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rules: {
    type: Object,
  },
},
  emits: ["onClickAddressInput", "update:value"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const roadAddress = computed(() => props.value?.roadAddress);
const detailAddress = computed({
  get(): string {
    return props.value?.detailAddress ?? "";
  },
  set(detailAddress: string) {
    const value = { ...props.value, detailAddress };
    emit("update:value", value);
  },
});

const shouldShowAddressModal = ref(false);
const toggleShowAddressModal = (show: boolean) => {
  shouldShowAddressModal.value = show;
};
const updateAddress = (address: Address) => {
  emit("update:value", address);
};

const __returned__ = { props, emit, roadAddress, detailAddress, shouldShowAddressModal, toggleShowAddressModal, updateAddress, get Field() { return Field }, TextInput, KakaoAddressModal, PageModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})